<template>
  <div class="detail">
    <div class="box-border">
      <div class="pr">
        <div class="detail-headImg-border" style="max-height: 390px;">
          <img :src="data.avatar_image" class="detail-headImg" alt />
        </div>
        <div class="pa-t0 flex between align">
          <span class="clr-white fz-18">{{ data.name }}</span>
          <img :src="Number(data.genderdata) === 1 ? icon.man : icon.girl" class="img-sex" alt />
        </div>
      </div>
      <div class="flex mt-15">
        <img :src="icon.address" class="detail-map" alt />
        <div style="text-align: left; margin-top: -3px;">
          <div class="clr-deepGrey fz-12">{{ data.city }}</div>
          <div class="clr-deepGrey fz-12"></div>
        </div>
      </div>
      <div class="detail-tel" v-if="data.wechat">{{ data.wechat }}</div>
      <div class="detail-tel" v-if="data.qq">QQ：{{ data.qq }}</div>
      <div class="detail-tel" v-if="data.mobile">手机：{{ data.mobile }}</div>
      <div class="detail-tel" v-if="data.email" style="margin-bottom: 25px">邮箱：{{ data.email }}</div>
      <div class="flex between">
        <div>
          <div class="fz-18 clr-black">{{ data.price }}元/次</div>
          <div class="fz-14 clr-deepGrey">咨询费用</div>
        </div>
        <div>
          <div class="fz-18 clr-black">{{ data.exp }}+小时</div>
          <div class="fz-14 clr-deepGrey">咨询经验</div>
        </div>
        <div>
          <div class="fz-18 clr-black">
            <span>{{ (data.method || '').replace('video','视频').replace('onsite','面询').replace(',','/') }}</span>
          </div>
          <div class="fz-14 clr-deepGrey">咨询方式</div>
        </div>
      </div>
    </div>
    <div class="box-border">
      <div class="title">个人介绍</div>
      <div class="introduce" v-html="data.intro_content"></div>
    </div>

    <div class="box-border" v-for="(item, index) in tagList" v-if="data.tag[item.id].length > 0" :key="index">
      <div class="title">{{ item.name }}</div>
      <div class="flex wrap">
        <span v-for="(tag,tagIndex) in (data.tag[item.id] || [])" :key="tagIndex" class="label">{{ tag.name }}</span>
      </div>
    </div>

    <div class="box-border" v-if="data.jobsjson">
      <div class="title">资质</div>
      <div v-for="(item, index) in JSON.parse(data.jobsjson)" :key="index" class="flex item-border">
				<span class="item-label">{{ item.tag }}</span>
				<span class="item-text" style="text-align: left;">{{ item.name }}</span>
      </div>
    </div>

    <div class="box-border" v-if="data.trainingjson">
      <div class="title">受训</div>
      <div v-for="(item, index) in JSON.parse(data.trainingjson)" :key="index" class="flex item-border">
				<span class="item-label">{{ item.tag }}</span>
				<span class="item-text" style="text-align: left;">{{ item.name }}</span>
      </div>
    </div>
    <div class="box-border">
      <img src="@/static/qrcode.jpg" class="ecode" alt />
      <div class="etext">添加小助理，预约咨询</div>
    </div>
    <div class="share flex between align">
      <div class="btn-homePage" @click="gohome">
        <img src="@/static/back.svg" width="100%" height="100%" alt />
      </div>
      <img :src="icon.share" @click="share = true" class="btn-share" alt />
    </div>

    <div v-show="share" @click="share = false" class="mask-share">
      <img :src="icon.shareMask" class="icon-arrow" alt />
      <img src="@/static/icon-share.png" class="icon-share" alt />
    </div>
  </div>
</template>
<script>
import request from '@/common/request'
import icon from '@/common/icon'
export default {
  data() {
    return {
      id: 0,
      data: {
        tag: [],
        jobsjson: '[]',
        trainingjson: '[]'
      },
      share: false,
      tagList: []
    }
  },

  computed: {
    icon() {
      return icon
    }
  },
  created(opt) {
    this.id = parseInt(this.$route.query.id || 0)
    this.initData()
  },
  methods: {
    initData() {
      this.getTag()
      this.getList()
    },
    gohome() {
      this.$router.back();
    },
    getTag() {
      this.$http.get('/index/getTag').then(res => {
        this.tagList = res.data.data
      })
    },
    getList() {
      this.$http
        .post('/index/list', {
          where: {
            id: this.id
          },
          page: this.page
        })
        .then(res => {
          // debugger
          this.data = res.data.data.data[0]
        })
    }
  }
}
</script>
<style>
@import url('../common/style.css');
</style>